import { defineAction } from '~/prix'
import actionJson from './machineServiceDocumentCreate.action.json' with { type: 'json' }
import { machineServiceDocumentObject } from '../machineServiceDocumentObject'
import { z } from 'zod'

const definition = defineAction({
  ...actionJson,
  input: machineServiceDocumentObject
    .pick({ id: true, machineServiceId: true, fileName: true, mimeType: true })
    .extend({
      fileName: z.string().min(1, 'Nome do arquivo é obrigatório'),
    })
    .partial({ id: true }),
  output: z.object({
    publicUrl: z.string().nullish(),
    uploadUrl: z.string(),
    fileId: z.string().uuid(),
    objectPath: z.string(),
    requiredHeaders: z.record(z.string()),
  }),
})

export default definition
